import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PUBLICACOES } from "@/content/site";
import { Container, Eyebrow, H2, Body, ArrowLink, Reveal } from "@/components/site/ui";
import Temas from "@/components/site/Temas";

export const useTexts = () =>
    useQuery({ queryKey: ["texts"], queryFn: async () => (await api.get("/texts")).data });

export const fmtLongDate = (iso) =>
    new Date(iso).toLocaleDateString("pt-BR", { month: "long", year: "numeric" });

const PublicacoesPreview = () => {
    const { data } = useTexts();
    return (
        <section data-testid="home-publicacoes" data-section-id="publicacoes" className="relative bg-[#F2EFE5] text-[#0E2018] py-24 md:py-32 overflow-hidden">
            <div aria-hidden="true" className="absolute inset-0 paper-grain" />
            <Container className="relative">
                <Reveal className="max-w-3xl">
                    <Eyebrow light>{PUBLICACOES.eyebrow}</Eyebrow>
                    <H2 light>{PUBLICACOES.title}</H2>
                    <Body light className="mt-6 max-w-2xl">{PUBLICACOES.lead}</Body>
                    <p className="mt-10 font-sans text-[10px] uppercase tracking-[0.28em] text-[#6b6a52]">{PUBLICACOES.temasTitulo}</p>
                </Reveal>
                <Reveal className="mt-4 py-8 border-y border-[#0E2018]/15" delay={100}>
                    <Temas light />
                </Reveal>
                <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-px bg-[#0E2018]/10">
                    {(data || []).slice(0, 3).map((t, i) => (
                        <Reveal key={t.id} delay={150 + i * 100} className="bg-[#F2EFE5]">
                            <Link to={`/publicacoes#${t.slug}`} data-testid={`home-pub-${t.slug}`} className="group flex flex-col h-full p-7 md:p-8 hover:bg-[#ebe6d8] transition-colors">
                                <p className="font-sans text-[10px] uppercase tracking-[0.24em] text-[#8a6a22]">
                                    {t.kind === "paper" ? "Artigo · SSRN" : "Ensaio"} · {fmtLongDate(t.created_at)}
                                </p>
                                <h3 className="mt-4 font-serif font-light text-[19px] md:text-[21px] leading-[1.35] text-[#0E2018]">{t.title}</h3>
                                <p className="mt-4 font-sans font-light text-[13px] leading-[1.7] text-[#2d3a31] line-clamp-3">{t.excerpt}</p>
                                <span className="mt-auto pt-6 font-sans text-[11px] uppercase tracking-[0.22em] text-[#0E2018] group-hover:text-[#8a6a22] transition-colors">Ler →</span>
                            </Link>
                        </Reveal>
                    ))}
                </div>
                <div className="mt-12">
                    <ArrowLink to="/publicacoes" testId="home-publicacoes-link" light>Todas as publicações</ArrowLink>
                </div>
            </Container>
        </section>
    );
};

export default PublicacoesPreview;
